<template>
    <div v-clickaway="closeContextMenu">
        <div :class="dotsIconClass" @click="toggleContextMenu">
            <common-icon name="dots-dark" size="medium"></common-icon>
        </div>

        <common-dropdown
            v-show="isContextMenuOpen"
            :hasArrow="false"
            arrowPositionX="top"
            arrowPositionY="right"
            class="context-menu context-menu__position"
        >
            <common-content-wrapper width="medium">
                <common-content-spacer
                    v-for="(item, index) of items"
                    :key="index"
                    class="context-menu__item"
                    height="tiny"
                    @click="executeItem(item)"
                >
                    {{ item.label }}
                </common-content-spacer>
            </common-content-wrapper>
        </common-dropdown>
    </div>
</template>

<script>
    export default {
        props: {
            items: { type: Array, required: true },
        },
        data() {
            return {
                isContextMenuOpen: false,
            }
        },

        computed: {
            dotsIconClass() {
                return {
                    'context-menu__dots': true,
                    'context-menu__dots--open': this.isContextMenuOpen,
                }
            },
        },

        methods: {
            openContextMenu() {
                this.isContextMenuOpen = true
            },

            closeContextMenu() {
                this.isContextMenuOpen = false
            },

            toggleContextMenu() {
                this.isContextMenuOpen = !this.isContextMenuOpen
            },

            executeItem(item) {
                this.emitEvent({ name: item.name })
            },
        },
    }
</script>
